import {
	type CommandConstructor,
	type CommandProperties,
} from '@atlassian/rovo-content-bridge-api/command';
import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';

export interface JiraContextCommandProperties extends CommandProperties {}

// Jira Context Command Types and Implementation
export type JiraContextData = {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	draftWorkItems: any;
};

/**
 * Result type for the Jira context command.
 */
export type JiraContextCommandResult = {
	success: boolean;
	context: JiraContextData;
	error?: string;
};

/**
 * A command sent by a bridge API client to retrieve Jira-specific context
 * information when operating in a Jira staging area environment.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to provide current Jira context information.
 */
export const JiraContextCommand: CommandConstructor<
	JiraContextCommandProperties,
	JiraContextCommandResult
> = createCommand<JiraContextCommandProperties, JiraContextCommandResult>('jira-context-command');
